var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.spinner,
    _vm.fullScreen && _vm.$style.fullScreen
  ],style:(_vm.styleObj)},[_c('div',{class:_vm.$style.bounce1,style:(_vm.circleStyle)}),_c('div',{class:_vm.$style.bounce2,style:(_vm.circleStyle)}),_c('div',{class:_vm.$style.bounce3,style:(_vm.circleStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }